module.exports = __webpack_public_path__ + "static/img/led_difuso_verde_5mm-1.3f27cb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/led_difuso_verde_5mm-1.svg
// module id = ajtw
// module chunks = 0